module.exports = __webpack_public_path__ + "static/media/caution3.4cd0d518.png";